import { ArrowRightStartOnRectangleIcon as Logout } from '@heroicons/react/24/outline';
import 'twin.macro';
import Button from 'components/Buttons/Button';
import { useAuth } from 'containers/App/context/AuthContext';
import React from 'react';
import { Menu } from 'components/Menu';
import { useTranslation } from 'react-i18next';

export function LogoutMenuItem() {
  const { t } = useTranslation(['common']);
  const { logout } = useAuth();

  return (
    <Menu.Item>
      <Button
        tw="whitespace-nowrap rounded-none font-normal"
        onClick={() => logout()}
        aria-label="menu profile fermer la session"
        minimal
        fill
        alignText="left"
        large
        icon={Logout}
      >
        {t('common:userProfileMenu.logout')}
      </Button>
    </Menu.Item>
  );
}
